import "./signin.scss";
import { inject, observer } from "mobx-react";
import { useEffect } from "react";

import { Form, Modal } from "react-bootstrap";
import { Formik } from "formik";
import PhoneInputField from "sharedComponents/PhoneInputField";

import cross from "images/cross.svg";

import { validationsSignIn } from "../../Validation/index";

const SignIn = ({
  token,
  loginUser,
  approvedPhone,
  cleanErrorRegistration,
  error,
  setRegistrationModal,
  setNewPasswordModal,

  setSignInModal,
  ...props
}) => {
  useEffect(() => {
    if (approvedPhone === "0") {
      setTimeout(() => {
        setSignInModal(false);
      }, 500);
    }
  });

  if (token) {
    setTimeout(() => {
      setSignInModal(false);
    }, 500);
  }

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Body className="signin">
        <p>
          <img
            src={cross}
            className="signin-img"
            onClick={() => {
              setSignInModal(false);
              cleanErrorRegistration();
            }}
            alt=""
          />
        </p>
        <Formik
          initialValues={{
            phone: "",
            password: ""
          }}
          validateOnBlur
          onSubmit={async (values) => {
            await loginUser(values);
          }}
          validationSchema={validationsSignIn}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            isValid,
            handleSubmit,
            dirty
          }) => (
            <div className="signin-form">
              <Form>
                <p className="registration-form-title">Вход в систему</p>

                <PhoneInputField name="phone" title="Номер телефона" />

                <Form.Group className="p-2 col-example text-left">
                  <Form.Label>Пароль</Form.Label>
                  <Form.Control
                    type="password"
                    name="password"
                    placeholder="Введите пароль"
                    className="input-form signin-placeholder"
                    isInvalid={touched.password && errors.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.password}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="p-2 col-example signin-rows">
                  <p
                    className="signin-link"
                    onClick={() => {
                      setSignInModal(false);

                      setNewPasswordModal(true);
                    }}
                  >
                    Я забыл пароль
                  </p>

                  <p
                    onClick={() => {
                      setSignInModal(false);
                      setRegistrationModal(true);
                    }}
                    className="signin-link"
                  >
                    Зарегистрироваться
                  </p>
                </Form.Group>

                <div>
                  <button
                    className="signin-btn"
                    type="submit"
                    disabled={!isValid || !dirty}
                    onClick={handleSubmit}
                  >
                    Войти
                  </button>
                </div>

                {error ? (
                  <p className="signin-form-error">
                    Такого пользователя не существует или пароль введен
                    неправильно
                  </p>
                ) : (
                  ""
                )}
              </Form>
            </div>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default inject(({ usersStore, modalWindows }) => {
  const {
    token,
    approvedPhone,
    registration,
    loginUser,
    cleanErrorRegistration,
    error
  } = usersStore;
  const { setSignInModal, setRegistrationModal, setNewPasswordModal } =
    modalWindows;

  return {
    token,
    approvedPhone,
    registration,
    loginUser,
    cleanErrorRegistration,
    error,

    setSignInModal,
    setRegistrationModal,
    setNewPasswordModal
  };
})(observer(SignIn));
